import { Payload } from "@neworbit/redux-helpers";
import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { TeamApi } from "./teamApi";
import * as actions from "./actionTypes";
import { TeamListModel, TeamCreateModel, TeamDetailModel, TeamEditModel } from "./model";

import { push } from "redux-little-router";

export type TeamAction =
    ({ type: typeof actions.LOAD_TEAMS_SUCCESS } & Payload<TeamListModel[]>) |
    ({ type: typeof actions.LOAD_TEAM_SUCCESS } & Payload<TeamDetailModel>) |
    ({ type: typeof actions.CREATE_TEAM_SUCCESS } & Payload<TeamListModel>) |
    ({ type: typeof actions.SAVE_TEAM_SUCCESS } & Payload<TeamDetailModel>) |
    ({ type: typeof actions.DELETE_TEAM_SUCCESS } & Payload<string>);

export const loadTeamsSuccess = (payload: TeamListModel[]): TeamAction => ({
    payload,
    type: actions.LOAD_TEAMS_SUCCESS
});

export const loadTeamSuccess = (payload: TeamDetailModel): TeamAction => ({
    payload,
    type: actions.LOAD_TEAM_SUCCESS
});

export const createTeamSuccess = (payload: TeamListModel): TeamAction => ({
    payload,
    type: actions.CREATE_TEAM_SUCCESS
});

export const saveTeamSuccess = (payload: TeamDetailModel): TeamAction => ({
    payload,
    type: actions.SAVE_TEAM_SUCCESS
});

export const deleteTeamSuccess = (id: string): TeamAction => ({
    payload: id,
    type: actions.DELETE_TEAM_SUCCESS
});

export function loadTeams() {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.LOAD_TEAMS, TeamApi.getAll());
        dispatch(loadTeamsSuccess(result));
    };
}

export function loadTeamDetail({ teamId }: { teamId: string }) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.LOAD_TEAM_DETAIL, TeamApi.get(teamId));
        dispatch(loadTeamSuccess(result));
    };
}

export function createTeam(team: TeamCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.CREATE_TEAM, TeamApi.create(team));
        dispatch(createTeamSuccess(result));
        dispatch(push(`${path}/${result.id}`));
    };
}

export function saveTeam(team: TeamEditModel, path: string) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.SAVE_TEAM, TeamApi.save(team));
        dispatch(saveTeamSuccess(result));
        dispatch(push(path));
    };
}

export function deleteTeam(id: string, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, actions.DELETE_TEAM, TeamApi.delete(id));
        dispatch(deleteTeamSuccess(id));
        dispatch(push(path));
    };
}
